import {AngularFireAuth} from 'angularfire2/auth';
import {AngularFireDatabase, AngularFireList} from 'angularfire2/database';

export abstract class BaseRepo {
  constructor(protected  af: AngularFireAuth, protected  db?: AngularFireDatabase) {

  }

  public getList(path: string): AngularFireList<any> {
    return this.db.list(path);
  }

  public getSingle(path: string) {
    return this.db.object(path);
  }

  public createObject(path: string, item: any) {
    return this.getList(path).push(item);
  }

  public updateObject(path: string, data) {
    return this.getSingle(path).update(data).then((r) => {
    }, (e) => {
      console.log('not updated', e);
    });
  }

  public removeObject(path: string, key: string) {
    return this.db.list(path).remove(key).then((r) => {
    }, (e) => {
      console.log('not removed', e);
    });
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/DAL/BaseRepo.ts